import guest 	from './rules/guest';
import user 	from './rules/user';
import verified from './rules/verified';

export default {
	guest,
	user,
	verified
}